module.exports = __webpack_public_path__ + "static/img/footer_trial_03_zh.78398af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer_trial_03_zh.png
// module id = k0O7
// module chunks = 34